import A11yMenu from './_a11yMenu';
import Swiper from 'swiper';
import {
	Navigation, A11y,
} from 'swiper/modules';
import GLightbox from 'glightbox';
import IsInView from './_isInView';

import {
	OverlayScrollbars,
	ScrollbarsHidingPlugin,
	ClickScrollPlugin,
	SizeObserverPlugin,
} from 'overlayscrollbars';

const initScrollbars = () => {
	const scrolls = document.querySelectorAll('.js-scrollbar');
	if (scrolls) {
		OverlayScrollbars.plugin([SizeObserverPlugin, ScrollbarsHidingPlugin, ClickScrollPlugin]);
		scrolls.forEach((elt) => {
			OverlayScrollbars(elt, {
				overflow: {
					y: 'hidden',
				},
				scrollbars: {
					theme: 'os-theme-dark',
					visibility: 'auto',
					clickScroll: true,
				},
			}, {
				updated(osInstance) {
					// For accessibility

					const scrollableDiv = osInstance.elements().content;
					if (osInstance.state().hasOverflow.x) {
						scrollableDiv.setAttribute('tabindex', 0);
						scrollableDiv.setAttribute('role', 'region');
						scrollableDiv.setAttribute('aria-label', 'Contenu avec scroll');
					} else {
						scrollableDiv.setAttribute('tabindex', -1);
						scrollableDiv.removeAttribute('role');
						scrollableDiv.removeAttribute('aria-label');
					}
				},
			});
		});
	}
};

const initMultiBlocksSlider = () => {
	const sliders = document.querySelectorAll('.multiblocks-swiper');
	sliders.forEach((elt) => {
		const nbCols = elt.getAttribute('data-tabCols');
		const swiper = new Swiper(elt, {
			modules: [Navigation, A11y],
			slidesPerView: 1,
			spaceBetween: 32,
			enabled: true,
			init: false,
			watchOverflow: false,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
				prevSlideMessage: 'élément précédent',
				nextSlideMessage: 'élément suivant',
			},
			navigation: {
				nextEl: elt.querySelector('.swp-button-next'),
				prevEl: elt.querySelector('.swp-button-next'),
				clickable: true,
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
					enabled: true,
				},
				720: {
					slidesPerView: nbCols,
					enabled: true,
				},
				960: {
					enabled: false,
				},
			},
		});

		swiper.on('breakpoint', (swipe, breakpointParams) => {
			if (!breakpointParams.enabled) {
				swipe.el.classList.add('disabled');
			} else {
				swipe.el.classList.remove('disabled');
			}
		});
		swiper.init();
	});
};

const initGallerySlider = () => {
	const sliders = document.querySelectorAll('.gallery-swiper');
	sliders.forEach((elt) => {
		const swiper = new Swiper(elt, {
			modules: [Navigation, A11y],
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 32,
			init: false,
			autoHeight: false,
			grabCursor: true,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
				scrollOnFocus: true,
				wrapperLiveRegion: false,
				prevSlideMessage: 'élément précédent',
				nextSlideMessage: 'élément suivant',
			},
			navigation: {
				nextEl: elt.closest('.wp-block-smblocks-gallery').querySelector('.swp-button-next'),
				prevEl: elt.closest('.wp-block-smblocks-gallery').querySelector('.swp-button-prev'),
				clickable: true,
			},
			breakpoints: {
				1024: {
					slidesPerView: elt.dataset.nb,
				},
			},
		});
		swiper.init();
	});
};

const initTestimonialSlider = () => {
	const sliders = document.querySelectorAll('.testimonials-swiper');
	sliders.forEach((elt) => {
		const swiper = new Swiper(elt, {
			modules: [Navigation, A11y],
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 40,
			init: false,
			autoHeight: false,
			grabCursor: true,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
				scrollOnFocus: true,
				wrapperLiveRegion: false,
				prevSlideMessage: 'élément précédent',
				nextSlideMessage: 'élément suivant',
			},
			navigation: {
				nextEl: elt.closest('.wp-block-smblocks-commentaires').querySelector('.swp-button-next'),
				prevEl: elt.closest('.wp-block-smblocks-commentaires').querySelector('.swp-button-prev'),
				clickable: true,
			},
			breakpoints: {
				1024: {
					slidesPerView: elt.dataset.nb,
				},
			},
		});
		swiper.init();
	});
};

const videoReduceMotion = () => {
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	const bgVideos = document.querySelectorAll('video[muted][autoplay]');

	bgVideos.forEach((vid) => {
		const control = vid.parentElement.querySelector('.hero__control');
		if (control) {
			control.removeAttribute('hidden');

			if (prefersReducedMotion.matches) {
				control.classList.add('showAlways');
			}

			control.addEventListener('click', () => {
				if (vid.paused) {
					vid.play();
					control.querySelector('#hero__control__button').textContent = 'Pause';
					control.querySelector('.play').classList.add('hidden');
					control.querySelector('.pause').classList.remove('hidden');
				} else {
					vid.pause();
					control.querySelector('#hero__control__button').textContent = 'Play';
					control.querySelector('.pause').classList.add('hidden');
					control.querySelector('.play').classList.remove('hidden');
				}
			});
		}
	});

	if (prefersReducedMotion.matches) {
		bgVideos.forEach((vid) => {
			vid.pause();
		});
	}

	prefersReducedMotion.addEventListener('change', () => {
		if (prefersReducedMotion.matches) {
			bgVideos.forEach((vid) => {
				vid.pause();

				const control = vid.parentElement.querySelector('.hero__control');
				if (control) {
					control.removeAttribute('hidden');
				}
			});
		} else {
			bgVideos.forEach((vid) => {
				vid.play();
			});
		}
	});
};

document.addEventListener('DOMContentLoaded', () => {
	const menu = new A11yMenu(document.querySelector('.a11y-nav-block'), '70rem');
	menu.menuSetup();

	initMultiBlocksSlider();
	initTestimonialSlider();
	initGallerySlider();

	/* A11y for Hero video */
	videoReduceMotion();

	initScrollbars();

	const lightbox = GLightbox({
		touchNavigation: true,
		loop: true,
	});

	// ANIMATIONS
	if ('IntersectionObserver' in window) {
		const checkInView = new IsInView('.is-in-view', 0.20);
		checkInView.init();
	}

	const openQuizzButtons = document.querySelectorAll('#open_quizz');
	if (openQuizzButtons) {
		openQuizzButtons.forEach((elt) => {
			elt.addEventListener('click', (e) => {
				e.preventDefault();
				const quizz = document.querySelector('.tf-v1-sidetab');
				if (quizz) {
					const button = quizz.querySelector('button.tf-v1-sidetab-button');
					button.click();
				}
				return false;
			});
		});
	}
});
